import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { Option } from "../../../../types/General/Option";
import { AuthUser } from "../../../../types/User/AuthUser";

interface IndicatorSelectComponent {
  fieldNameObject: string;
  options: Option[];
  fieldName: string;
  width: string;
  control: any;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  isDisabled?: boolean;
  defaultValue?: string | number | null;
  isLoaded: boolean;
}

export const indicatorTableSelectFilterData = (
  stateOptions: Option[],
  provinceOptions: Option[],
  countyOptions: Option[],
  control: any,
  setFilter: (filterName: string, value?: string) => void,
  setSelectedState: Dispatch<SetStateAction<string | null>>,
  setSelectedProvince: Dispatch<SetStateAction<Option | null>>,
  setSelectedCounty: Dispatch<SetStateAction<string | null>>,
  selectedProvince: Option | null,
  indicatorLevel: Option | null,
  provinceLoaded: boolean,
  countyLoaded: boolean,
  stateLoaded: boolean,
  user: AuthUser,
): IndicatorSelectComponent[] => {
  const handleStateOptionsChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedStateId = e.target.value;
    setSelectedState(e.target.selectedOptions[0].text);
    setFilter("StateId", selectedStateId);
  };

  const handleProvinceChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedProvinceId = e.target.value;
    const selected = provinceOptions.find(
      (p) => p.id.toString() === selectedProvinceId,
    );
    setSelectedProvince(selected || null);
    setFilter("ProvinceId", selectedProvinceId);
  };

  const handleCountyChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedCountyId = e.target.value;
    setSelectedCounty(e.target.selectedOptions[0].text);
    setFilter("CountyId", selectedCountyId);
  };

  return [
    {
      fieldNameObject: "StateId",
      options: stateOptions,
      fieldName: "Estado do indicador",
      control: control,
      width: "230px",
      onChange: handleStateOptionsChange,
      isLoaded: stateLoaded,
    },

    {
      fieldNameObject: "ProvinceId",
      options: provinceOptions,
      fieldName: "Província",
      control: control,
      width: "230px",
      onChange: handleProvinceChange,
      isDisabled:
        (user?.role?.level !== undefined && user?.role.level.id >= 4) ||
        indicatorLevel?.id.toString() === "1",
      isLoaded: provinceLoaded,
      defaultValue:
        user?.role?.level !== undefined && user?.role.level.id >= 4
          ? user.province?.id
          : "",
    },

    {
      fieldNameObject: "CountyId",
      options: countyOptions,
      fieldName: "Município",
      control: control,
      width: "230px",
      onChange: handleCountyChange,
      isDisabled:
        (user?.role?.level !== undefined && user?.role.level.id === 5) ||
        indicatorLevel?.id.toString() !== "3" ||
        !selectedProvince ||
        selectedProvince.name === "",
      defaultValue:
        user?.role?.level !== undefined && user?.role.level.id === 5
          ? user.county?.id
          : "",
      isLoaded: countyLoaded,
    },
  ];
};
